/*******************************************************
 * Copyright (C) 2010-Present Avant Assessment
 * All Rights Reserved
 *******************************************************/

import React from "react"
import {useEffect, useState} from "react"

import Button from "@material-ui/core/Button"
import {Box, Paper, Stack, Tooltip} from "@mui/material"
import PersonAdd from "@material-ui/icons/PersonAdd"
import PlayArrowIcon from "@material-ui/icons/PlayArrow"
import StopIcon from "@material-ui/icons/Stop"
import CleverRosterApi from "../../../../services/CleverRosterApi"
import {CleverAdhocRosterDialog} from "./rostering/CleverAdhocRosterDialog"
import {CleverAdhocTeacherRosterDialog} from "./rostering/CleverAdhocTeacherRosterDialog"
import {CustomAdminView} from "./dialogs/CustomAdminsView"
import {
    navigateToTestTakerSearch,
} from "../../../reports/common/components/TestTakerSearch/components/TestTakerSearchLink"
import {useHistory} from "react-router"
import {theme} from "../../../../styles/MuiThemes"

interface CleverCustomSectionsProps {
    handleStartGroup: () => void
    handleStopGroup: () => void
    handleCloseRoster: () => void
}

/** Despite the name this function includes both custom and non-custom controls.
 *  TODO - move non-custom controls to parent component or separate component */
export const CleverCustomSections: React.FC<CleverCustomSectionsProps> = (props) => {
    const [rosterOpen, setRosterOpen] = useState(false)
    const [customAdminOpen, setCustomAdminOpen] = useState(false)
    const [rosterTeacherOpen, setRosterTeacherOpen] = useState(false)
    const [customRosteringEnabled, setCustomRosteringEnabled] = useState(false)
    const history = useHistory()

    useEffect(() => {
        CleverRosterApi.customSectionsAllowed().then((response) => setCustomRosteringEnabled(response))
    }, [])


    const handleRosterStudents = () => {
        setRosterOpen(true)
    }
    const handleRosterTeachers = () => {
        setRosterTeacherOpen(true)
    }
    const handleRosterClose = () => {
        setRosterOpen(false)
        setRosterTeacherOpen(false)
        props.handleCloseRoster()

    }

    const handleCustomAdminViewClose = () => {
        setCustomAdminOpen(false)
    }
    const handleCustomAdminViewOpen = () => {
        setCustomAdminOpen(true)
    }

    return (
        <>
            <>
                <Paper elevation={3} sx={{padding: 3}}>
                    <Stack gap={2} sx={{paddingLeft: 4, paddingRight: 4}}>
                        <Box sx={{
                            display: "grid",
                            justifyItems: "stretch",
                            gap: 2,
                            [theme.breakpoints.up("md")]: {
                                gridTemplateColumns: "1fr 1fr",
                                gap: 12
                            }
                        }}>
                            <Tooltip title={"Disallow all students to enter the test."}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    startIcon={<StopIcon/>}
                                    onClick={props.handleStopGroup}
                                >
                                    Lock all tests
                                </Button>
                            </Tooltip>
                            <Tooltip title={"Allow all students to enter the test."}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    startIcon={<PlayArrowIcon/>}
                                    onClick={props.handleStartGroup}
                                >
                                    Unlock all tests
                                </Button>
                            </Tooltip>
                        </Box>
                        {customRosteringEnabled &&
                            <>
                                <Box sx={{
                                    display: "grid",
                                    gap: 2,
                                    [theme.breakpoints.up("md")]: {
                                        gridTemplateColumns: "1fr 1fr"
                                    }
                                }
                                }>
                                    <Tooltip title={"Roster Student to Custom Sections"}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            startIcon={<PersonAdd/>}
                                            onClick={handleRosterStudents}
                                        >
                                            Roster Custom Sections
                                        </Button>
                                    </Tooltip>
                                    <Tooltip title={"Assign Staff to Custom Sections"}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            startIcon={<PersonAdd/>}
                                            onClick={handleRosterTeachers}
                                        >
                                            Assign Teachers & Staff
                                        </Button>
                                    </Tooltip>
                                </Box>
                                <Tooltip title={"View Custom Admins"}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        fullWidth={true}
                                        onClick={handleCustomAdminViewOpen}
                                    >
                                        View Custom Admins
                                    </Button>
                                </Tooltip>
                            </>
                        }
                        <Tooltip title={"Search for Individual Test Takers"}>
                            <Button variant="contained"
                                    color="primary"
                                    fullWidth={true}
                                    onClick={() => navigateToTestTakerSearch(history, undefined)}>
                                Test Taker Search
                            </Button>
                        </Tooltip>
                    </Stack>
                </Paper>
                <CleverAdhocRosterDialog
                    open={rosterOpen}
                    handleRosterClose={handleRosterClose}
                />
                <CleverAdhocTeacherRosterDialog
                    open={rosterTeacherOpen}
                    handleRosterClose={handleRosterClose}
                />
                <CustomAdminView
                    open={customAdminOpen}
                    onClose={handleCustomAdminViewClose}
                />
            </>
        </>
    )
}
